import React from "react";
import { useState, useEffect } from "react";
// import Pagination from "../../components/Pagination/Pagination";
import AxiosService from "../../utils/AxiosService";
import {toast } from "react-toastify";
// import AuthServiceStroage from "../../utils/auth_service/AuthServiceStorage";
// import PaginationInfo from "../../components/PaginationInfo/PaginationInfo";
import UpdateManuscriptStatus from "./UpdateManuscriptStatus";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import AssignUserPage from "./AssignUserPage";
import ExportReport from  "./ExportReport";
import CommentReport from "./CommentReport";
import DoiFilters from "./DoiFilters";
import { isValidToken } from "../../utils/auth_service/AuthServiceHelper";
import { useNavigate } from "react-router-dom";
import { APPLICATION_NAME } from "../../utils/Constant";
import OverAllReport from "./OverAllReport";

const Manager = () => {
    const apiService = new AxiosService();
  const [activeTab, setActiveTab] = useState(null);
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState("");
  const [projectStatusReport, setprojectStatusReport] = useState([]);
   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
   const navigate = useNavigate();
    useEffect(() => {
      apiService
        .getProjectList()
        .then((response) => {
          console.log(response.data);
          setProjects(response.data.data);
        })
        .catch((error) => {
            if(!isValidToken(error.response.data.message)){
              toast.error("Please Login to Continue", { autoClose: 2000 });
              navigate(`/${APPLICATION_NAME}/login`);
            }else{
              toast.error(error.response.data.message, { autoClose: 2000 });
            }
            
        });
    }, []);


      useEffect(() => {
        if (project !== "") {
          apiService
            .getProjectStatusReport(project)
            .then((response) => {
              setprojectStatusReport(response.data.data);
            })
            .catch((error) => {
              toast.error(error.response.data.message, { autoClose: 3000 });
            });
        }
      }, [project]);

  const tabs = [
    { label: "Update Manuscript Status", value: "UpdateManuscriptStatus" },
    { label: "Assign User", value: "assignUser" },
    { label: "Export Report", value: "exportReport" },
    { label: "Comment Report", value: "commentReport" },
    // { label: "Over All Report", value: "OverAllReport" },
    // { label: "DOI Filters", value:"doiFilters" },
  ];

  const renderContent = () => {
    console.log(activeTab);
    switch (activeTab) {
      case "UpdateManuscriptStatus":
        return <UpdateManuscriptStatus projectId={project}/>
      case "assignUser":
        return <AssignUserPage projectStatusReport={projectStatusReport} projectId={project}/>
      case "exportReport":
        return <ExportReport projectId={project} />
      case "commentReport":
        return <CommentReport projectId={project} />
      case "doiFilters":
        return <DoiFilters projectId={project}/>
      // case "OverAllReport":
      //   return <OverAllReport projectId={project}/>
      default:
        return <></>;
    }
  };
const localStorageService = LocalStorageService.getService();
    const handleProjectChange = (event) => {
      const projectId=event.target.value
      setProject(projectId);
      const selectedProject = projects.find(
        (project) => {
          if(project.projectId == projectId){
            return project;
          }
        }
      );
      localStorageService.setProjectDetails(JSON.stringify({ projectId: projectId, projectName : selectedProject ? selectedProject.projectName : "" }))
    };


    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
  return (
    <div className="flex min-h-screen bg-gray-100">
      <div className="flex-1 flex flex-col">
        <div className="d-flex">
          <div className="container-fluid">
            <div className="row w-100 min-vh-100">
              {/* Sidebar */}
              {/* <div className="col-2 bg-white shadow-sm min-vh-100 p-1"> */}
              {/* <h3 className="text-lg font-bold mb-4">Main Menu</h3> */}
              <div
                className={
                  "bg-light text-black transition-all duration-300 shadow p-1"
                }
                style={{ width: `${isSidebarOpen ? "10%" : "16%"} ` }}
              >
                {/* Sidebar Toggle Button */}
                <button
                  className="mb-1 w-full text-left bg-bg-secondary text-black rounded"
                  onClick={toggleSidebar}
                >
                  {isSidebarOpen ? (
                    <FontAwesomeIcon icon={faBars} size="sm" />
                  ) : (
                    <FontAwesomeIcon icon={faArrowLeft} />
                  )}
                </button>

                {/* <ul className="space-y-2 "> */}
                {tabs.map((tab) => (
                  <div className={`d-${isSidebarOpen ? "none" : "block"} p-1`}>
                    <input
                      type="button"
                      className={`w-100 text-left p-1 border  border-0 ${
                        activeTab === tab.value
                          ? "text-black font-bold"
                          : "hover:bg-gray"
                      }  transition-all`}
                      onClick={() => setActiveTab(tab.value)}
                      value={tab.label}
                    />
                  </div>
                ))}
                {/* </ul> */}
              </div>
              {/* </div> */}
              {/* Main Content Area */}
              <div className="col-10 p-2 h-100">{renderContent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



export default Manager;
